import {
  computed,
  reactive,
  ref,
  onBeforeMount,
  getCurrentInstance,
} from '@vue/composition-api';

import DefaultImage from '@/assets/images/icons/no-img-square.jpg';

export default function useCustomerEditModal(customerDetail) {
  const vm = getCurrentInstance().proxy;

  const customerForm = reactive({
    name: null,
    mobile: null,
    lineId: null,
    email: null,
    birthDate: null,
    imageUrl: null,
  });

  const initCustomerForm = () => {
    customerForm.name = customerDetail.name;
    customerForm.mobile = customerDetail.details.mobile;
    customerForm.email = customerDetail.details.email;
    customerForm.lineId = customerDetail.details.lineId;
    customerForm.birthDate = resolveDate(customerDetail.details.birthDate);
    customerForm.imageUrl = customerDetail.imageUrl;
  };

  const renderImageUrl = computed(() => {
    let img = customerForm.imageUrl || DefaultImage;

    return {
      'background-image': `url(` + img + `)`,
    };
  });

  const handleUploadChange = (e) => {
    let filesOBJ = e.target.files[0];
    try {
      let imageUrl = URL.createObjectURL(filesOBJ);
      //   props.formData.logo_ImageFormData = filesOBJ;
      customerForm.imageUrl = imageUrl;
    } catch {}
  };

  const onUpload = () => {
    vm.$refs.refInputEl.click();
  };

  const resolveDate = (date) => {
    const dateObject = new Date(date);

    return `${dateObject.getFullYear()}-${dateObject.getMonth()}-${dateObject.getDate()}`;
  };

  return {
    customerForm,
    renderImageUrl,
    handleUploadChange,
    onUpload,
    initCustomerForm,
  };
}
